module.exports = __webpack_public_path__ + "static/img/403.5b2e2aa9.svg";